import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Input from '../../../form/Input'
import Button from '../../../../UniformComponents/Button'
import Typography from '../../../../UniformComponents/Typography'

@observer
class AiSummaries extends Component {
    render() {
        const { props } = this
        const {
            getPrompt, handleSurveyIdBlur, generateSummary,
            generatingPrompt, generatingSummary, promptOutput,
        } = props.store

        return (
            <div>
                <Typography>Survey ID</Typography>

                <br />

                <Input
                    type="text"
                    placeholder="00000000-0000-0000-0000-000000000000"
                    onBlur={handleSurveyIdBlur}
                />

                <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                    <Button
                        cssClass="regular tertiary"
                        label="Generate prompt"
                        onClick={getPrompt}
                        disabled={generatingPrompt || generatingSummary}
                    />

                    <Button
                        cssClass="regular tertiary"
                        label="Generate summary"
                        onClick={generateSummary}
                        disabled={generatingPrompt || generatingSummary}
                    />
                </div>

                <br />

                <Typography>Output</Typography>

                <div style={{
                    marginTop: 20, padding: 20, border: '1px solid black', borderRadius: 6, minHeight: 100, width: '100%',
                }}
                >
                    {generatingPrompt ? 'Generating prompt...' : ''}
                    {generatingSummary ? 'Generating summary...' : ''}
                    {!generatingSummary && !generatingPrompt ? <Typography>{promptOutput}</Typography> : null}
                </div>
            </div>
        )
    }
}

export default AiSummaries
